import {
    postZoneLoading,
    postZoneRequest,
    postZoneSuccess,
    postZoneReject,
    postZoneReset
} from "../../actions/zone/post";

export const postZone = (formData) => async (dispatch, getState) => {
    dispatch(postZoneLoading());
    try {
        const { data } = await postZoneRequest(formData, getState);
        dispatch(postZoneSuccess(data))
    } catch (error) {
        dispatch(postZoneReject(error))
    } finally {
        setTimeout(() => { dispatch(postZoneReset()) }, 3000);
    }
    return Promise.resolve();
};